import React from "react";
import ReactDOM from "react-dom/client";
import "./css/reset.css";
import App from "./App";
import { BrowserRouter } from "react-router-dom";
import ScrollToTop from "./modules/ScrollToTop";

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
    <React.StrictMode>
        <BrowserRouter basename={process.env.PUBLIC_URL}>
            <ScrollToTop />
            <App />
        </BrowserRouter>
    </React.StrictMode>
);
